import dayjs from "dayjs";

export const TIMESHEET_ROLE_INFO_MESSAGE = {
  hr_manager_info_message:
    "Approve Employee Requests: Review and Approve Time Off & Non-Working Hours",
  contract_manager_info_message:
    "Approve Team Requests: Review & Approve Billable/Non-Billable Hours of Your Team",
  timesheet_admin_info_message:
    "Timesheet Admin: Review & Approve All Project & Leave Timesheets"
};

export const TS_APPROVAL_OPTIONS = {
  project_timesheets: "Project Timesheets",
  time_off_unplanned: "Time-Off / Unplanned Timesheets",
  system_timesheets: "System Timesheets",
  unknown_type: "Unknown Type"
};

export const TIMESHEET_STATUS = {
  not_submitted: "not_submitted",
  submitted: "submitted",
  recall: "recall",
  approved: "approved",
  empty: "",
  submitted_msg: "Your timesheet has been submitted for approval",
  recall_msg: "The approver has recalled your timesheet",
  approved_msg: "Your timesheet has been successfully approved",
  not_submitted_msg: "",
  submitted_btn: "Submitted",
  recall_btn: "Recalled",
  approved_btn: "Approved",
  not_submitted_btn: "Not Submitted"
};

export const TIMESHEET_STATUS_PRIORITY = [
  TIMESHEET_STATUS.not_submitted,
  TIMESHEET_STATUS.recall,
  TIMESHEET_STATUS.submitted,
  TIMESHEET_STATUS.approved,
  TIMESHEET_STATUS.empty
];

export const extractFinalStatus = (obj) => {
  let statuses = [];

  const traverse = (currentObj) => {
    if (Array.isArray(currentObj)) {
      for (let item of currentObj) {
        traverse(item);
      }
    } else if (typeof currentObj === "object" && currentObj !== null) {
      for (let key in currentObj) {
        if (
          currentObj.hasOwnProperty(key) &&
          (key === "status" || key.includes("_status"))
        ) {
          if (currentObj[key]) {
            statuses.push(currentObj[key]);
          }
        }
        traverse(currentObj[key]);
      }
    }
  };

  traverse(obj);

  for (let status of TIMESHEET_STATUS_PRIORITY) {
    if (statuses.includes(status)) {
      return status;
    }
  }

  return null;
};

export const getTimesheetButtonText = (obj) => {
  const status = extractFinalStatus(obj);
  const buttonText = TIMESHEET_STATUS[`${status}_btn`] || "Unknown Status";
  return buttonText;
};

export const getTimesheetStatusMessage = (obj) => {
  const status = extractFinalStatus(obj);
  if (status === TIMESHEET_STATUS.not_submitted) return "";
  return TIMESHEET_STATUS[`${status}_msg`] || "Unknown Status";
};
